import React from "react";
import { useAuth } from "../componentes/Auth/AuthContext/AuthContext";
import LoginButton from "../componentes/Auth/Login/LoginButton"; // Importa o botão de Login

const HomeDashboard = () => {
  const { isAuthenticated, userData, isLoadingUserData } = useAuth();

  // Exibe tela de carregamento enquanto os dados são carregados
  if (isLoadingUserData) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <h1 className="text-xl font-semibold text-gray-700">
          Carregando dados do usuário...
        </h1>
      </div>
    );
  }

  // Exibe mensagem caso o usuário não esteja autenticado
  if (!isAuthenticated) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <h1 className="text-xl font-semibold text-gray-700">
          Bem-vindo! Faça login para continuar...
        </h1>
        <div className="w-48">
          <LoginButton />
        </div>
      </div>
    );
  }

  // Dados do usuário autenticado
  const { displayName, email, photo } = userData?.user || {};

  return (
    <div className="flex h-screen items-center justify-center bg-gray-100 p-5">
      <div className="bg-white shadow-md rounded-lg p-6 max-w-sm w-full text-center">
        {/* Foto do usuário */}
        {photo ? (
          <img
            src={`data:image/jpeg;base64,${photo}`}
            alt="User Avatar"
            className="w-24 h-24 rounded-full mx-auto mb-4 border-4 border-gray-200 shadow-sm"
          />
        ) : (
          <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center mx-auto mb-4">
            <span className="text-gray-500 text-4xl">?</span>
          </div>
        )}

        {/* Mensagem de boas-vindas */}
        <h1 className="text-2xl font-bold text-gray-700 mb-2">
          Olá, {displayName || "Usuário"}!
        </h1>

        {/* Informações adicionais */}
        <p className="text-gray-500 text-sm mb-4">
          {email || "E-mail não disponível"}
        </p>

        {/* Mensagem complementar */}
        <p className="text-gray-600">
          Seja bem-vindo ao SIC, o Sistema integrado ConTI. Aproveite seu dia!
        </p>
      </div>
    </div>
  );
};

export default HomeDashboard;
